<div>
<div class="mt-3 breadcrumb-link">  
    <span><  </span>  
    <a routerLink="/home"> Back to Client Tenant List</a>
  </div>
  <div class="page-title d-flex mb-3">
    <div>
      <h3>{{ tenantName }}</h3>
    </div>
    <div class="mt-n2 ml-auto">
        <button type="button" class="btn btn-secondary" (click)='onDeleteClientTenantButtonClick()' [disabled]="disableBtn">Delete Tenant</button>
      </div>
  </div>
  <div class="container">
    <div class="row">
      <div class="d-flex flex-column">
        <label class="font-weight-bold">Database Name: </label>
        <label class="font-weight-bold">Job Name: </label>
      </div>
      <div class="d-flex flex-column">
        <label>{{ tenantDetail.databaseName }}</label>
        <label>{{ tenantDetail.tenantJobName }}</label>
      </div>
      <div class="d-flex flex-column">
        <label class="font-weight-bold">Last Run Date: </label>
        <label class="font-weight-bold">Last Run Outcome: </label>
      </div>
      <div class="d-flex flex-column">
        <label>{{ tenantDetail.lastRunDateString }}</label>
        <span>
          <label class="status-icon" *ngIf="lastRunOutcome === 'Failed'">
            <img src="../../../../assets/icons/ErrorIcon.png" > 
            {{ lastRunOutcome }}
          </label>    
          <label class="status-icon" *ngIf="lastRunOutcome === 'Succeeded'">
            <img src="../../../../assets/icons/Checkmark.png">
            {{ lastRunOutcome }}
          </label> 
        </span>
      </div>
    </div>
  </div>
    <div class="horizontal"></div>
    
  <div class="d-flex flex-row"> 
        <div *ngIf="isJobRunning" >
        <div class="d-flex mb-3"><span>Processing {{surveyRunning}} of {{surveyCount}} survey/s.</span></div>
        <div class="d-flex mb-3" >      
          <div class="font-weight-bold d-flex mr-3">Current Execution Step:</div>    
          <img src="../../../../assets/icons/Processing.png">
          <div> {{ currentExecutionStep }}</div> 
        </div>
      </div>
    </div>      
    <div id="surveys" class="grid-container">
      <ag-grid-angular class="ag-theme-alpine" style="overflow: hidden; width: 300px; height: auto;"
                      [gridOptions]="gridOptions"                     
                      (gridReady)="onGridReady($event)"
                      (selectionChanged)="onSelectionChanged($event)"
                      >
      </ag-grid-angular>
      </div> 
 <div class="errorLogsDiv">
      <div [hidden]="hideValidationError">
        <label class="font-weight-bold">Survey Validation Rules</label>
        <div id="survey-validation" class="grid-container">
          <ag-grid-angular class="ag-theme-alpine grid" 
                          [gridOptions]="gridOptionsSurveyValidation"   
                          (gridReady)="onGridReady($event)" 
                          (gridSizeChanged)="onGridSizeChangedValidation($event)"              
                          style="width: 100%; height: 100px;" >
          </ag-grid-angular>   
        </div>    
      </div>
    <div class="error-section" [hidden]="hideErrorLogs">     
        <label class="font-weight-bold">Survey Job Logs</label>
          <div id="survey-joblogs" class="grid-container">
            <ag-grid-angular class="ag-theme-alpine grid" 
                            [gridOptions]="gridOptionsJobLogs"
                            (gridReady)="onGridReady($event)" 
                            (gridSizeChanged)="onGridSizeChangedETL($event)" 
                            style="width: 100%; height: 100px;" >
            </ag-grid-angular>   
          </div>      
        <label class="font-weight-bold">Survey Job Step Logs</label>     
        <div id="survey-jobSteplogs" class="grid-container"> 
          <ag-grid-angular class="ag-theme-alpine grid"  
                          [gridOptions]="gridOptionsJobStepLogs"
                          (gridSizeChanged)="onGridSizeChangedETL($event)" 
                          (gridReady)="onGridReady($event)" 
                          style="width: 100%; height: 100px;" >
          </ag-grid-angular>  
        </div>
    </div> 
  </div>

  <div class="d-flex flex-row mb-5" id="detailsFooter">
    <div class="col-sm-12 d-flex justify-content-end p-0">
      <div>
        <button type="button" class="btn btn-secondary" [disabled]="disableBtn" (click)='onDeleteTenantDataButtonClick()'>Delete Data</button>
        <button type="button" class="btn btn-secondary"[disabled]="disableBtn || !isSurveySelected" (click)='onDeleteSurveyClick()' >Delete Survey</button>
        <button type="button" class="btn btn-secondary" (click)='refresh()'>Refresh</button>
      </div>
      <div class="ml-auto" id="jobBtnDiv">
        <button type="button" class="btn btn-primary" (click)='onRunJobButtonClick()' [disabled]="disableBtn" >Run Job</button>
      </div>
    </div>
 </div>
</div>